import * as nativeComponentAPI from '../../../../api/nativeComponentAPI'
import VisibleComponent from "./VisibleComponent";
import NativeComponent from "../NativeComponent";

const nativeComponentAbility = NativeComponent.nativeComponentAbility

class StoreKitView extends VisibleComponent {
    constructor (options) {
        const action = nativeComponentAPI.createStoreKitView
        super(action, {
            ...options,
            params: options
        })
    }

    /**
     * 预加载skt
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    preload(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.preloadStoreKit(_params)
    }


    /**
     * 将skt添加到其他视图上
     * @override
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    appendTo(target, rect) {
        console.log('appendTo===>', this.id, target,target.id)
        if(target instanceof VisibleComponent){
            return target.whenCreateSuccess().then(()=>{
            const params = {
                id: target.id,
                rect  : {"top":10,"bottom":20,"left":20,"right":30,"width":320,"height":480}
            }
            const _params = this.getInvokeParams(params)
                console.log('appendTo22===>', _params)
            return nativeComponentAPI.addStoreKitTo(_params)
        })
        // 如果是appendTo到rootView到情况
        }else if(target.id){
            const params = {
                id: target.id,
                rect
            }
            const _params = this.getInvokeParams(params)
            return nativeComponentAPI.addStoreKitTo(_params)
        }

    }


    /**
     * 在skt上添加其他视图
     * @override
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    append(params) {
        return new Promise((resolve, reject)=>{
            console.error('storeKit视图目前不支持append方法！')
            reject()
        })
    }
}

export default StoreKitView